import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '../Elements'
import { Phone, Logo, LogoAr, Download } from '../AllImages'
import { Container, Row } from 'react-bootstrap'
import { ButtonWithIcon, ButtonWithIcon2 } from '../CustomElements'

import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { BsJustify, BsX } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import { Linkedin } from 'react-bootstrap-icons'
import LangChangeButton from '../../Languages/LangChangeButton'
import { NavDataConfig } from './HeaderData'
import i18n from '../../Languages/INEXT'
const Header = () => {
    const navigate = useNavigate()
    const WhatsApp = () => {
        const phoneNumber = '+966555625502';
        const message = 'Hello, this is Hisas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = "http://hisas.fowl.sa/بروفايل شركة حصص العقارية.pdf"; // path to your PDF
        link.download = "بروفايل شركة حصص العقارية.pdf"; // name when saved
        link.click();
    };
    const { t } = useTranslation();
    const [isSticky, setIsSticky] = useState(false);
    const [toggle, setToggle] = useState(false);
    const handleToggle = () => {
        setToggle(!toggle);
        const element = document.querySelector(".nav-bar-list");
        element.classList.toggle("showToggle");
    };
    const SocialLinkSnap = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkLinkedIn = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkInstagram = () => {
        window.open('https://www.instagram.com/sheelandmore?igsh=MW8xMHVzOHhsODUweg==', '_blank');
    };
    const SocialLinkTwitter = () => {
        window.open('https://x.com/sheelandmore?s=11', '_blank');
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <HeaderContainer className={`${isSticky ? 'sticky' : ''} container-fluid`}>
                <Container>
                    <Row>
                        <Box className='nav-bar'>
                            <Box className='logoHeader' onClick={() => navigate('/')}>
                                {i18n.language === "ar" ? <Logo /> : <Logo />}
                            </Box>
                            <Box className='nav-bar-list'>
                                {NavDataConfig.map((item, key) => (
                                    <Box key={key}>
                                        <Link to={item.to} spy={true} smooth={true} offset={-99} duration={500} activeClass="active" onClick={handleToggle}><span className='menuNumber'>{t(item.number)}</span>{t(item.label)}</Link>
                                    </Box>
                                ))}
                                <ButtonWithIcon2 className="mobileView" icon={Download} label={t('DownloadCompanyProfile')} onClick={handleDownload} />
                            </Box>
                            <Box className='d-flex align-items-center headerBtnsContainer'>
                                {/* <Box className='d-flex align-items-center socialLinksContainer'>
                                    <Box className='socialLinks'><Snapchat onClick={SocialLinkSnap} /></Box>
                                    <Box className='socialLinks'><LinkedIn onClick={SocialLinkLinkedIn} /></Box>
                                    <Box className='socialLinks'><Instagram onClick={SocialLinkInstagram} /></Box>
                                    <Box className='socialLinks'><Twitter onClick={SocialLinkTwitter} /></Box>
                                </Box> */}
                                <ButtonWithIcon2 className="desktopView" icon={Download} label={t('DownloadCompanyProfile')} onClick={handleDownload} />
                                <LangChangeButton />
                                <span className="toggleBtn" onClick={handleToggle}>
                                    {toggle ? <BsX size={30} /> : <BsJustify size={30} />}
                                </span>
                            </Box>
                        </Box>
                    </Row>
                </Container>
            </HeaderContainer>
        </>
    )
}
const HeaderContainer = styled.header`
    -webkit-transition: all .3s ease-out 0s;
    transition: all .3s ease-out 0s;
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 24px;
    .logo{
        cursor:pointer;
    }
    .socialLinks{
        cursor: pointer;
    }
    .socialLinksContainer{
        display: flex;
        gap: 16px;
    }
    .menuNumber{
        display: none;
        color: var(--secondaryColor);
    }
    .nav-bar{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
    .nav-bar-list{
        display:flex;  
        align-items: center;
        gap: 3px;
    }
    .nav-bar-list a{
        color:var(--bg2);
        padding: 0px 12px;
        line-height: 40px;
        position: relative;
        font-size: 18px;
        font-family: var(--medium);
        border-radius: 24px;
        border: 1px solid transparent;
        display: block;
        cursor: pointer;
        &:hover{
            background: transparent;
            font-family: var(--medium);
            color:var(--bg2);
            /* border: 1px solid var(--bg2); */
        }
        &:focus, &.active{
            padding: 0px 25px;
            background: transparent;
            font-family: var(--semiBold);
            color:var(--bg2);
            border: 1px solid var(--bg2);
        }
        
    }
    .headerBtnsContainer{
        gap: 12px;
    }
    .mobileView{
        display: none !important;
    }
    body.rtl &{
        .nav-bar-list a{
            font-family: var(--jannaRegular);
            &:hover{
                font-family: var(--jannaRegular);
            }
            &:focus, &.active{
                font-family: var(--jannaBold);
            }
        }
    }
    @media (max-width: 1299px) {
        .headerBtnsContainer {
            gap: 5px;
        }
        .logoHeader{
            svg{
                width: 200px;
                height: auto;
            }
            
        }
        .nav-bar-list a{
            padding: 0px 10px;
            
            &:focus, &.active{
                /* padding: 0px 15px; */
                
            }
            
        }
    }
    @media (max-width: 1199px) {
        .menuNumber{
            display: inline-block;
        }
        .nav-bar-list{
            gap: 0px;
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .headerBtnsContainer{
            gap: 5px;
        }
        .headerWhatsapp button{
            padding: 11px 15px;
        }
        .nav-bar-list a{
            padding: 5px 20px;
            margin-top: 5px;
            margin-bottom: 5px;
            display: flex;
            font-size: 20px;
            align-items: center;
            gap: 16px;
            border: none;
            width: fit-content;
            &:focus, &.active{
                padding: 5px 20px;
                border: none;
                color: var(--gold);
            }
        }
        .logoHeader{
            svg{
                width: 200px;
                height: auto;
            }
            
        }
    }
    @media (max-width: 767px) {
        
        .socialLinksContainer{
            display: none !important;
        }
    }
    @media (max-width: 640px) {
        padding-top: 15px;
        padding-bottom: 15px;
        .socialLinksContainer{
            gap: 8px;
        }
        .mobileView{
            display: flex !important;
        }
        .desktopView{
            display: none !important;
        }
        .mobileView > button{
            width: 100%;
            border-radius: 0;
            &:hover{
                background: var(--themeColor);
            }
        }
    }
    @media (max-width: 550px) {
        .socialLinksContainer{
            display: none !important;
        }
        .logoHeader{
            width: 170px;
            svg{
                width: 100%;
                height: auto;
            }
        }
    }
    @media (max-width: 390px) {
        .headerWhatsapp{
            display: none !important;
        }
    }
`
export default Header
